import { Component, OnInit } from "@angular/core";
import { ReportService } from "../report.service";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { PrintReportManualRequest } from "../../student/student-digital-id-registration/shared/PrintReportManualRequest";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { AcademyService } from "../report-services/academy.service";

@Component({
	selector: "app-student-digital-idreg",
	templateUrl: "./student-digital-idreg.component.html",
	styleUrls: ["./student-digital-idreg.component.css"],
})
export class StudentDigitalIDRegComponent implements OnInit {
	constructor(
		private reportService: ReportService,
		private selectService: SchoolselectorService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.onExpireDayCountChange(30);

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////

	//
	//	Can't Run the report for all schools
	//		Reports WCF runs out of memory
	//		(Could print a report for each school and zip them?)
	//
	// SchoolSelectShowAllID: any = 0;
	// SchoolSelectShowAllText: any = "All Schools";

	subscription: any;

	DigitalIDURL: string = ""; //Filled in by Server
	CurrentUserID: number = -1; //Filled in by Server

	ExpireDayCount: number = 0;
	ExpireDate: Date = new Date();

	SelectedSchool: any;

	SelectedGradeLevel: any;
	lstGradeLevel: any = [];

	SelectedAcademy: any;
	lstAcademy: any = [];

	SelectedHomeroom: any;
	lstHomeroom: any = [];

	SelectedGroup: any;
	lstGroup: any = [];

	ActiveID: number = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	AlreadyPrintedID: number = 1;
	lstAlreadyPrintedOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Already Printed",
		},
		{
			ID: 0,
			Desc: "Not Printed Yet",
		},
	];

	SortBy: string = "FirstName";
	lstSortBy: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "StudentID",
			Desc: "Student ID",
		},
		{
			ID: "GradeLevel",
			Desc: "Grade",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "Academy",
			Desc: "Academy",
		},
	];

	SortDirection: string = "ASC";
	lstSortDirection: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	ReportOutputTypeID: number = 1;
	lstReportOutputType: any = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		// {
		// 	ID: 4,
		// 	Desc: ".CSV (Excel file)",
		// },
		{
			ID: 5,
			Desc: ".rtf (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	SelectedImageLogo: any;
	lstImageLogo: any = [];

	ReportID: number = 463;
	strSP: string = "uspx_RptDigitalIDQRSelectList";

	lstParmNames: string[] = [
		"@ExpireDays",
		"@DigitalIDURL",
		"@GradeLevelID",
		"@HomeroomID",
		"@AcademyID",
		"@GroupID",
		"@Active",
		"@AlreadyPrinted",
		"@SortBy",
		"@SortDirection",
		"@CurrentUserID",
		"@SchoolID",
	];

	LoadingGradeLevel: boolean = false;
	LoadingHomeroom: boolean = false;
	LoadingAcademy: boolean = false;
	LoadingGroup: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.gradelevelService.loadGradeLevelList(0, this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.SelectedGradeLevel = this.lstGradeLevel[0];
				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.academyService.loadAcademyList(0, this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.SelectedAcademy = this.lstAcademy[0];
				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.homeroomService.loadHomeroomList(0, this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.SelectedHomeroom = this.lstHomeroom[0];
				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.groupService.loadGroupList(0, this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.SelectedGroup = this.lstGroup[0];
				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////

	onPrint() {
		this.errorMessage = "";

		this.Processing = true;

		var lstParmVals: any[] = [
			this.ExpireDayCount,
			this.DigitalIDURL, //Send Blank
			this.SelectedGradeLevel.GradeLevelID,
			this.SelectedHomeroom.HomeroomId,
			this.SelectedAcademy.AcademyId,
			this.SelectedGroup.GroupID,
			this.ActiveID,
			this.AlreadyPrintedID,
			this.SortBy,
			this.SortDirection,
			this.CurrentUserID, //Send Blank
			this.SelectedSchool.SchoolID,
		];

		var parms: PrintReportManualRequest = {
			ReportID: this.ReportID,
			SchoolID: this.SelectedSchool.SchoolID,
			strSP: this.strSP,
			lstReportParmNames: this.lstParmNames,
			lstReportParmValues: lstParmVals,
			ReportOutputType: this.ReportOutputTypeID,
			UserID: -1,
		};

		var result = this.reportService.PrintReportManual(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;
				window.open(response);
			},
			(error) => {
				this.Processing = false;
				this.errorMessage = error;
			}
		);
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////

	onExpireDayCountChange(val) {
		this.ExpireDayCount = val;

		var newDate = new Date();
		newDate.setDate(newDate.getDate() + this.ExpireDayCount);

		this.ExpireDate = newDate;
	}

	onExpireDateChange(val) {
		this.ExpireDate = val;

		var TodayInt = new Date().getTime();
		var ExpireDateInt = this.ExpireDate.getTime();

		var TodayDay = Math.floor(TodayInt / 1000 / 60 / 60 / 24);
		var ExpireDateDay = Math.floor(ExpireDateInt / 1000 / 60 / 60 / 24);

		var DateDiff = ExpireDateDay - TodayDay;

		if (DateDiff < 0) {
			this.ExpireDate = new Date();
			this.ExpireDayCount = 0;
		} else {
			this.ExpireDayCount = DateDiff;
		}
	}

	onSchoolChange(school) {
		this.SelectedSchool = school;

		//Load Data
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////

	IsLoading() {
		return (
			this.LoadingGradeLevel == true ||
			this.LoadingHomeroom == true ||
			this.LoadingAcademy == true ||
			this.LoadingGroup == true ||
			this.Processing == true
		);
	}

	/////////////////////////////////////////////////
}
